// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. Refactor.
// Base class for binding orderEdit object and user input.
import { DynProperty } from '@shared/commons/DynProperty';
import { Resources } from '@shared/localizations/Resources';
import { MessageBoxType } from '@shared/utils/MessageBoxUtils';
import { TerceraMessageBox } from '../screen/TerceraMessageBox';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { OrderEditBase } from '@shared/commons/cache/OrderParams/order-edit/OrderEditBase';
import { ApplicationPanelWithTable } from './ApplicationPanelWithTable';
import { WDSettingsUtils } from '../UtilsClasses/WDGeneralSettingsUtils';
import { BaseSettings } from '@shared/commons/Settings/BaseGeneralSettingsWrapper';
export class OrderEditViewBase extends ApplicationPanelWithTable {
    constructor() {
        super(...arguments);
        this.orderEdit = null;
        this.parameterObserverHandler = null;
    }
    get account() {
        return this.get('account');
    }
    get instrument() {
        return this.get('instrument');
    }
    oninit() {
        super.oninit();
        this.on('onUserCommentChanged', (_context, _ractiveEvent, inputStr) => {
            this.onUserCommentChanged(inputStr);
        });
        this.observe('isVisibleOTHTrading', () => {
            this.updateIsAllowOTHTrading();
        });
    }
    getInstrument() {
        return this.get('instrument');
    }
    getType() {
        throw new Error('Not implemented');
    }
    dispose() {
        this.disposeOrderEdit();
        super.dispose();
    }
    disposeOrderEdit() {
        const parameterObserverHandler = this.parameterObserverHandler;
        if (!isNullOrUndefined(parameterObserverHandler)) {
            parameterObserverHandler.cancel();
        }
        this.parameterObserverHandler = null;
        void this.set('orderEditParameterArray', null);
        const orderEdit = this.orderEdit;
        if (isNullOrUndefined(orderEdit))
            return;
        this.orderEdit = null;
        orderEdit.ParametersChanged.UnSubscribe(this.onOrderEditParametersChanged, this);
        orderEdit.ValidStateChanged.UnSubscribe(this.onValidStateChanged, this);
        orderEdit.QuantityChanged.UnSubscribe(this.onQuantityChanged, this);
        orderEdit.dispose();
    }
    // TODO. Refactor.
    setOrderEdit(orderEdit) {
        if (isNullOrUndefined(orderEdit)) {
            return;
        }
        this.disposeOrderEdit();
        this.orderEdit = orderEdit;
        void this.set('orderEditParameterArray', orderEdit.createDynPropertyArrayFromParameters()).then(function () {
            this.onrender();
        }.bind(this));
        orderEdit.ParametersChanged.Subscribe(this.onOrderEditParametersChanged, this);
        orderEdit.ValidStateChanged.Subscribe(this.onValidStateChanged, this);
        // TODO. Refactor.
        this.onValidStateChanged(orderEdit.valid());
        this.parameterObserverHandler = this.observe('orderEditParameterArray.*', this.onOrderEditParameterChangedByUser, { init: false });
        orderEdit.QuantityChanged.Subscribe(this.onQuantityChanged, this);
        // TODO. UGLY. Refactor.
        this.deferLayout();
    }
    onQuantityChanged(qtyValue) { }
    onValidStateChanged(valid) {
        void this.set('tradingAllowed', valid);
    }
    // orderEdit parameters' -> parameters' controls.
    onOrderEditParametersChanged(dpDict) {
        const orderEdit = this.orderEdit;
        const orderEditParameterArray = this.get('orderEditParameterArray');
        if (isNullOrUndefined(dpDict) || isNullOrUndefined(orderEdit) || !isValidArray(orderEditParameterArray)) {
            return;
        }
        const updatedArray = orderEditParameterArray.map((param) => { var _a; return (_a = dpDict[param.name]) !== null && _a !== void 0 ? _a : param; });
        void this.set('orderEditParameterArray', updatedArray);
        // TODO. UGLY. Refactor.
        this.deferLayout();
    }
    // parameters' controls -> orderEdit parameters'.
    onOrderEditParameterChangedByUser(dp) {
        const orderEdit = this.orderEdit;
        if (isNullOrUndefined(orderEdit) || isNullOrUndefined(dp))
            return;
        const dpDict = {};
        dpDict[dp.name] = dp;
        orderEdit.updateParameters(new OrderEditUpdateData(dpDict));
        if (this.get('positionSizingChecked')) {
            orderEdit.recalcQtyForPositionSizing();
        }
    }
    deferLayout() {
        this.needLayout = true;
    }
    TickAsync() {
        if (!this.needLayout) {
            return;
        }
        this.needLayout = false;
        this.layout();
        this.activateNumeric_proc();
    }
    activateNumeric(numericLinkName) {
        if (!isValidString(numericLinkName)) {
            return;
        }
        const observerName = 'observerOf' + numericLinkName;
        this[observerName] = this.observe(numericLinkName, function (link, obsName, n) {
            if (!isNullOrUndefined(n)) {
                this.numericToActivate = n;
                this.obsName = obsName;
            }
        }.bind(this, numericLinkName, observerName));
    }
    activateNumeric_proc() {
        if (!isNullOrUndefined(this.numericToActivate)) {
            this.numericToActivate.setFocus(true, true);
            this.numericToActivate = null;
            const oName = this.obsName;
            if (!isNullOrUndefined(this[oName])) {
                this[oName].cancel();
                this[oName] = null;
                this.obsName = null;
            }
        }
    }
    layout() { }
    // TODO. Refactor. Remove?
    updateOrderEditParametersVisibility() {
        const orderEditParameterArray = this.get('orderEditParameterArray');
        if (!isValidArray(orderEditParameterArray))
            return;
        for (let i = 0, len = orderEditParameterArray.length; i < len; i++) {
            const dp = orderEditParameterArray[i];
            if (dp === null || dp === void 0 ? void 0 : dp.visible) {
                this.getOrderEditParameterVisibility(dp);
            }
        }
    }
    // TODO. Refactor. Remove?
    getOrderEditParameterVisibility(dp) {
        let result = false;
        switch (dp.type) {
            case DynProperty.DOUBLE:
                result = true;
                break;
            case DynProperty.POSITION_SIZING:
                if (dp.positionSizingIsVisible) {
                    result = true;
                }
                break;
            case DynProperty.SLTP: {
                const sltpDp = dp;
                if (sltpDp.allowedSL) {
                    result = true;
                }
                if (sltpDp.allowedTP) {
                    result = true;
                }
                if (sltpDp.sl.enabled === true) {
                    result = true;
                }
                if (sltpDp.tp.enabled === true) {
                    result = true;
                }
                if (sltpDp.SLTriggerVisible() || sltpDp.TPTriggerVisible()) {
                    result = true;
                } // #109798
                break;
            }
            case DynProperty.COMBOBOX:
                result = true;
                break;
            case DynProperty.PRODUCT_TYPE_AND_MQ:
                if (dp.visible) {
                    result = true;
                }
                break;
            case DynProperty.ATTENTION_MSG:
                if (dp.visible) {
                    result = true;
                }
                break;
        }
        return result;
    }
    focusWarningNumeric() {
        // for numeric focusing when it has warning after click button in confirmation screen of place/modify order
        let warningNumericData = null;
        if (!isNullOrUndefined(this.orderEdit)) {
            warningNumericData = this.orderEdit.getWarningNumeric();
        }
        if (isNullOrUndefined(warningNumericData)) {
            return;
        }
        const numericLinkKey = warningNumericData.numericLinkKey;
        const dpControlName = warningNumericData.dpControlName;
        if (isValidString(numericLinkKey)) {
            this.activateNumeric(numericLinkKey);
            void this.set(numericLinkKey, this.tryGetDynPropertyControlTradingNumeric(dpControlName));
            this.deferLayout();
        }
    }
    tryGetDynPropertyControlTradingNumeric(dpControlName) {
        const dpControl = !isNullOrUndefined(this.Controls) ? this.Controls[dpControlName] : null;
        if (!isNullOrUndefined(dpControl)) {
            return !isNullOrUndefined(dpControl.Controls) ? dpControl.Controls.TradingNumeric : null;
        }
        return null;
    }
    addDisclosedQuantityIfNeed(key) {
        const instrument = this.get('instrument');
        const orderEdit = this.orderEdit;
        const tif = this.get('tif');
        if (isNullOrUndefined(instrument) || isNullOrUndefined(orderEdit) || isNullOrUndefined(tif)) {
            return;
        }
        const needToAdd = OrderEditBase.isDisclosedQuantityNeed(instrument, orderEdit.getOrderTypeId(), tif);
        void this.set('disclosedQuantityShow', needToAdd &&
            !this.get('isCashQtyMode') &&
            !Resources.isHidden('panel.newOrderEntry.disclosedLabel'));
        // if (needToAdd) {
        this.setDisclosedQuantityParams(key);
        // }
    }
    setDisclosedQuantityParams(key) {
        const inLots = WDSettingsUtils.displayAmountInLots();
        const oldDQ = this.get('disclosedQuantity');
        const quantity = this.get('quantity');
        const ins = this.get('instrument');
        if (isValidNumber(quantity === null || quantity === void 0 ? void 0 : quantity.value) && (quantity === null || quantity === void 0 ? void 0 : quantity.value) !== 0) {
            const decimalPlaces = ins.getAmountPrecision(inLots, this.orderEdit.account, this.orderEdit.productType);
            const lotStep = ins.getLotStep(this.orderEdit.productType, this.orderEdit.account);
            const increment = inLots ? lotStep : lotStep * ins.LotSize;
            const disclosedQuantityMinCoefficient = ins.GetDisclosedQuantityMinCoefficient();
            const minValue = isValidNumber(disclosedQuantityMinCoefficient) && disclosedQuantityMinCoefficient !== 0
                ? quantity.value * disclosedQuantityMinCoefficient
                : increment;
            let minValueDeFacto = parseFloat(minValue.toFixed(decimalPlaces));
            if (minValueDeFacto < minValue) {
                minValueDeFacto += increment;
            }
            void this.set({
                dqMinValue: minValueDeFacto,
                dqMaxValue: quantity.value
            });
        }
        if ((oldDQ === null || oldDQ === void 0 ? void 0 : oldDQ.value) && key !== 'quantity') {
            return;
        }
        const order = this.get('order');
        const val = (order === null || order === void 0 ? void 0 : order.DisclosedQty) && key !== 'quantity'
            ? Quantity.convertQuantityValue(new Quantity(order.DisclosedQty, true), ins, inLots, this.orderEdit.account, this.orderEdit.productType)
            : quantity.value;
        void this.set('disclosedQuantity', new Quantity(val, inLots));
    }
    onUserCommentChanged(input) {
        if (isValidString(input) || input === '') {
            void this.set({ userComment: input });
        }
    }
    static CheckNumericsErrors(numericsErrors) {
        const keys = Object.keys(numericsErrors);
        const len = keys.length;
        for (let i = 0; i < len; i++) {
            const numericValidationStateInfo = numericsErrors[keys[i]];
            if ((numericValidationStateInfo === null || numericValidationStateInfo === void 0 ? void 0 : numericValidationStateInfo.enabled) && isValidString(numericValidationStateInfo.errorText)) {
                TerceraMessageBox.Show(Resources.getResource('screen.error.title'), numericValidationStateInfo.errorText, MessageBoxType.Info, null, null, false, true);
                return false;
            }
        }
        return true;
    }
    isShowCommentSelector() {
        var _a;
        const orderType = this.get('orderType');
        const instrument = this.getInstrument();
        const isEnabled = (_a = instrument === null || instrument === void 0 ? void 0 : instrument.IsCommentEnabled(orderType)) !== null && _a !== void 0 ? _a : false;
        void this.set('enableComment', isEnabled);
    }
    updateIsVisibleOTHTrading() {
        const account = this.account;
        const instrument = this.instrument;
        const isVisible = !isNullOrUndefined(account) && !isNullOrUndefined(instrument) && account.isAllowOTHTrading(instrument);
        this.set('isVisibleOTHTrading', isVisible);
    }
    updateIsAllowOTHTrading() {
        const isVisible = this.get('isVisibleOTHTrading');
        const isAllowOTHTrading = this.get('isAllowOTHTrading');
        if (isVisible) {
            if (isNullOrUndefined(isAllowOTHTrading)) {
                this.set('isAllowOTHTrading', BaseSettings.isAllowOTHTrading);
            }
        }
        else {
            this.set('isAllowOTHTrading', null);
        }
    }
}
ApplicationPanelWithTable.extendWith(OrderEditViewBase, {
    data: function () {
        return {
            DynProperty,
            orderEditParameterArray: null,
            quantity: null,
            tradingAllowed: false,
            isAllowedResponce: null, // backup result of calling IsAllowed.IsTradingAllowed - IsAllowedResponce type object
            tradingForbiddenReason: '',
            overnightExecutionTextKey: 'panel.newOrderEntry.OvernightExecution',
            overnightExecutionTooltipKeyActive: 'panel.newOrderEntry.OvernightExecution.Info.Active',
            overnightExecutionTooltipKeyInActive: 'panel.newOrderEntry.OvernightExecution.Info.InActive',
            isVisibleOTHTrading: false,
            isAllowOTHTrading: null,
            isAllowOTHTradingEvents: {
                onActiveChanged: (isActive) => {
                    this.set('isAllowOTHTrading', isActive);
                }
            }
        };
    }
});
